import React, { useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {
  selectPreSaleFlag,
  selectCurrentPhone,
  selectLanguage,
  selectCustomer
} from '../App/selectors'
import { selectLandingCategories } from '../FAQs/selectors'
import {
  ExpressContent,
  FilteredContent,
  ExpressFilter
} from '../../components'
import { createEvent } from '../UserEvents/actions'

const Wrapper = styled.div``

const ExpressHelpContainer = props => {
  const { params, expressCategories, language } = props

  const [inputValue, setInputValue] = useState('')
  const [faqs] = useState('')
  const [filtered, setFiltered] = useState('')

  const handleChange = e => {
    setInputValue(e.target.value)
    filterFaqs()
  }

  const clearInputValue = () => {
    setInputValue('')
  }

  const filterFaqs = () => {
    const filteredFaqs = findAllFaqs().filter(data =>
      data.name.toLowerCase().includes(inputValue.toLowerCase())
    )
    setFiltered(filteredFaqs)
  }

  const selectedFaqTitle = () => {
    const selectedFaq = findAllFaqs().find(
      data => parseInt(data.pk, 10) === parseInt(params.id, 10)
    )

    return selectedFaq ? selectedFaq.name : null
  }

  const findAllFaqs = () => {
    const subCategories = expressCategories.reduce(
      (list, categories) => [...list, ...categories.children],
      []
    )
    const faqsLists = subCategories.reduce(
      (list, subCategories) => [...list, ...subCategories.children],
      []
    )
    return faqsLists
  }

  const generateProps = () => ({
    ...props,
    ...{
      inputValue,
      faqs,
      filtered
    }
  })

  return (
    <Wrapper className="content-body">
      <ExpressFilter
        clearInputValue={e => clearInputValue(e)}
        language={language}
        handleChange={e => handleChange(e)}
        contentId={params.id}
        contentTitle={e => selectedFaqTitle(e)}
        inputValue={inputValue}
      />

      {inputValue ? (
        <FilteredContent {...generateProps()} />
      ) : (
        <ExpressContent {...generateProps()} />
      )}
    </Wrapper>
  )
}

const mapStateToProps = (state, ownProps) => ({
  language: selectLanguage(state),
  preSaleFlag: selectPreSaleFlag(state),
  currentPhone: selectCurrentPhone(state),
  location: ownProps.location,
  query: state.routing.locationBeforeTransitions.query,
  isLandingPage: ownProps.isLandingPage,
  expressCategories: selectLandingCategories(state),
  modalOpen: ownProps.modalOpen,
  customer: selectCustomer(state)
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event))
})

ExpressHelpContainer.propTypes = {
  params: PropTypes.object.isRequired,
  expressCategories: PropTypes.array.isRequired,
  language: PropTypes.string.isRequired
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpressHelpContainer)



// WEBPACK FOOTER //
// ./src/containers/ExpressHelp/ExpressHelp.js